import '../../assets/css/VideoConference.css';
import NurturixCustomTabs from '../../components/common/NurturixCustomTabs';

const PROVIDERS = [
  { key: "zoom", label: "Zoom" },
  { key: "google", label: "Google Meet" },
];

export default function VideoProviderSelector({ provider, setProvider, meetingCounts = {} }) {
  const tabs = PROVIDERS.map((p) => ({
    key: p.key,
    label: (
      <>
        <span className={`video-tab-dot video-tab-dot-${p.key}`} />
        {p.label}
        {meetingCounts[p.key] > 0 && (
          <span className="video-tab-badge">{meetingCounts[p.key]}</span>
        )}
      </>
    ),
  }));

  return (
    <div className="video-provider-tabs">
      <NurturixCustomTabs tabs={tabs} activeTab={provider} onTabChange={setProvider} />
    </div>
  );
}
